//Get Current URL
var url = window.location.href;

//Product Review Extensions
window.onload = function () {
  //Modify Prices
/*  var elements = document.querySelectorAll("span.price-item--regular");

  for (let i = 0; i < elements.length; i++) 
  {
    var price = elements[i].innerHTML.replace("€","").replace(",", ".") / 1.07;
    price = parseFloat(price).toFixed(2);
    var newPrice = "€" + price;
    elements[i].innerHTML = newPrice.replace(".",",");
  }


*/
  let hinweisMwSt = document.querySelector('.cart__shipping')
  hinweisMwSt.style.marginBottom = "5px !important"
  
  var hinweisVersandfrei = document.createElement('div');
  hinweisMwSt.after(hinweisVersandfrei)
  
  setInterval(function () {
    let price = document.querySelector('.cart-subtotal__price').innerText
    price = price.replace('€', '')
    price = price.replace(' EUR', '')
    price = parseFloat(price.replace(",", "."))
    if (price > 100.0){
      hinweisVersandfrei.innerHTML = '<p style="color:red;margin-top: -35px;margin-bottom: 10px;">Deine Bestellung ist jetzt versandkostenfrei</p>'
    }else{
      hinweisVersandfrei.innerHTML = ''
    }
  }, 2000);
  
  modifyCart();
  
  async function modifyCart()
  {
    if (url.includes("https://die-36-hohen-raete.net/cart"))
    {
      async function removeItem(data) {
          const result = await fetch("/cart/change.json", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              },
              body: JSON.stringify({
                  ...data,
                  quantity: 0
              })
          });

          return result.json();
      }

      async function removeItemById(id) {
          return removeItem({ id: id });
      }

      async function removeItemByLine(oneBasedLineIndex) {
          return removeItem({ line: oneBasedLineIndex });
      }

      async function addItem(variantId, quantity) {
          const result = await fetch("/cart/add.json", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              },
              body: JSON.stringify({
                  id: variantId,
                  quantity: quantity
              })
          })
      }

      async function getCart() {
          const result = await fetch("/cart.json");

          if (result.status === 200) {
              return result.json();
          }

          throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
      }

      function img_create(src)
      {
          var img = document.createElement('img');
          img.src = src;
          return img;
      }

      async function switchProducts()
      {
          if (buch1IDInCart) await removeItemById(buch1ID);
          if (buch2IDInCart) await removeItemById(buch2ID);
          if (buch3IDInCart) await removeItemById(buch3ID);

          await addItem(buch3in1, 1);

          //Reload Cart
          window.location.reload();
      }

      async function switchProducts2()
      {
          await addItem(buch1ID, 1);

          //Reload Cart
          window.location.reload();
      }

      var buch3in1 = "41911921377444";
      var buch1ID = "36669248864420";
      var buch2ID = "37126211076260";
      var buch3ID = "37148402450596";
      var buch3NaturgeisterID = "43688125923592";
      var buchHeilungID = "44688393961736";
      var buchFreiheitInDerLiebeID = "50227364462856";
      
      
      var buch1IDInCart = false;
      var buch2IDInCart = false;
      var buch3IDInCart = false;
      var buch3in1InCart = false;
      var buch3NaturgeisterInCart = false;
      var buchHeilungInCart = false;
      var buchFreiheitInDerLiebeCart = false;
      
      //Get Cart Content
      const cart = await getCart();

      //Check Cart Content
      cart.items.forEach((element, index, array) => {
          if (element.id == buch1ID)
              buch1IDInCart = true;

          if (element.id == buch2ID)
              buch2IDInCart = true;

          if (element.id == buch3ID)
              buch3IDInCart = true;

          if (element.id == buch3in1)
              buch3in1InCart = true;

          if (element.id == buch3NaturgeisterID)
              buch3NaturgeisterInCart = true;

          if (element.id == buchHeilungID)
              buchHeilungInCart = true;

          if (element.id == buchFreiheitInDerLiebeID)
              buchFreiheitInDerLiebeCart = true;
      });

      /*
      console.log(buch1IDInCart);
      console.log(buch2IDInCart);
      console.log(buch3IDInCart);
      */

      //Execute Logic
      if (buch1IDInCart && buch2IDInCart && buch3IDInCart)
      {
		  switchProducts();
      }
      else if ((buch3NaturgeisterInCart || buchHeilungInCart || buchFreiheitInDerLiebeCart) && !buch1IDInCart && !buch3in1InCart)
      {
          //Add Banner with Discount Action
          var banner = img_create("https://cdn.shopify.com/s/files/1/0502/3252/4964/files/Angebot-10_Rabatt-3Baende-weiss-warenkorb.jpg");
          banner.style.cursor = "pointer";

          banner.onclick = async function() 
          {
              switchProducts();
          };

          var header = document.createElement('p');
          header.innerHTML = 'Lege dies deinem Warenkorb hinzu und spare dir die Portokosten:';
          header.style.fontWeight = "bold";
          header.style.fontSize = "18px";
          header.style.marginBottom = "5px";

          var actionText = document.createElement('p');
          actionText.innerHTML = '<a href="javascript:void(0);" style="text-decoration: underline" id="actionLink">Band 1, 2 & 3 "Die 36 Hohen Räte“ | -10% Rabatt und Portofrei</a>';
          actionText.style.marginTop = "10px";

          var descriptionText = document.createElement('div');
          //descriptionText.innerHTML = '<h7>Band 2 – Offenbarungen der Heilung und der Erlösung</h7><br><br>Dieses Buch ist nun der zweite Band. Die Reise in ein tieferes Verständnis von der Wirklichkeit hinter dem Schleier geht weiter. Was ist die Merkaba? Wie funktioniert das Merkaba-Reisen? Was sind die Aspekte und wie ist der Lichtkörper aufgebaut? Was sind Lichtkörpersymptome und wie kann der Mensch mit ihnen umgehen? Wie sieht die Welt hinter dem Schleier tatsächlich aus und was kann man tun, um mit ihr in Kontakt zu treten? Dies sind nur einige der Fragen, auf die die 36 Hohen Räte voller Liebe eingehen werden.<br><br>Band 3 – Offenbarungen aus den Zeitepochen<br><br>Willkommen zum Band 3 der Buchreihe „Die 36 Hohen Räte“! Wer sind wir und wo kommen wir her? Entspricht die Geschichte der Menschheit – so, wie sie unsere Wissenschaftler uns glauben lassen möchten – der Wahrheit oder gibt es noch eine andere, allumfassendere Wahrheit? Eine Wahrheit, die vielleicht berührender nicht sein könnte? Eine Geschichte, in der jede Seele, jeder Mensch einen wichtigen Platz einnimmt – eingebunden in einen höheren Plan, getragen von einer liebenden Kraft?';
          
          descriptionText.innerHTML = 'In diesem Angebot sind natürlich auch die drei Audio-Channelings "Harmonie - Frieden - Liebe" enthalten.<br><br><b>Inhalt:</b><br>Band 1 – Offenbarungen der Liebe und des Erwachens<br>Band 2 – Offenbarungen der Heilung und der Erlösung<br>Band 3 – Offenbarungen aus den Zeitepochen<br>+ Channeling „Die vollkommene Harmonie in deiner Seele“ (30:00 Min)<br>+ Channeling „Der Frieden in dir“ (27:50 Min)<br>+ Channeling „Freiheit in der menschlichen Liebe“ (43:00 Min)';
          descriptionText.style.fontSize = "11px";
        
          //Add additional Separator
          var separator = document.createElement('hr');
          separator.style.borderTop = "border-bottom: 1px solid ebebeb";
          separator.style.marginBottom = "20px";
          separator.style.marginTop = "20px";
        
        
          var cartFooter = document.getElementsByClassName("cart__footer")[0];
          cartFooter.after(descriptionText);
          cartFooter.after(actionText); 
          cartFooter.after(banner); 
          cartFooter.after(header); 
          cartFooter.after(separator);
          
          document.getElementById("actionLink").onclick=async ()=>{
              switchProducts();
          };
      }
      /*else if ((buch3NaturgeisterInCart || buchHeilungInCart) && !buch1IDInCart && !buch3in1InCart)
      {
          //Add Banner with Discount Action
          var banner = img_create("https://cdn.shopify.com/s/files/1/0502/3252/4964/files/Band1-indenwarenkorb.jpg?v=1676279442");
          banner.style.cursor = "pointer";

          banner.onclick = async function() 
          {
              switchProducts2();
          };

          var headerAfterContinue = document.createElement('p');
          headerAfterContinue.innerHTML = '<a href="javascript:void(0);" style="text-decoration: none" id="actionLink3">Lege den Bestseller „Die 36 Hohen Räte – Band 1“ von Sabine Sangitar hinzu und spare 3,90€ Versandkosten:</a>';
          headerAfterContinue.style.fontWeight = "bold";
          headerAfterContinue.style.fontSize = "18px";
          headerAfterContinue.style.marginBottom = "5px";
          headerAfterContinue.style.marginTop= "10px";
        
          var afterContinue = document.querySelector("a.text-link:nth-child(2)");
          afterContinue.after(headerAfterContinue);
        
          var header = document.createElement('p');
          header.innerHTML = '<a href="javascript:void(0);" style="text-decoration: none" id="actionLink2">Lege den Bestseller „Die 36 Hohen Räte – Band 1“ von Sabine Sangitar hinzu und spare 3,90€ Versandkosten:</a>';
          header.style.fontWeight = "bold";
          header.style.fontSize = "18px";
          header.style.marginBottom = "5px";
        
          var cartFooter = document.getElementsByClassName("cart__footer")[0];
          cartFooter.after(banner); 
          cartFooter.after(header); 
          
          document.getElementById("actionLink2").onclick=async ()=>{
              switchProducts2();
          };

          document.getElementById("actionLink3").onclick=async ()=>{
              switchProducts2();
          };
      }*/
    }
  }
}